import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-db-background bg-cover" }
const _hoisted_2 = { class: "xl:absolute xl:right-0 md:w-3/5 m-auto xl:w-2/5" }
const _hoisted_3 = { class: "bg-white py-8 px-4 shadow sm:rounded-sm sm:px-10 md:mx-auto lg:w-3/4 w-full" }
const _hoisted_4 = { class: "sm:mx-auto sm:w-full sm:max-w-sm" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "mt-12 flex justify-center items-center gap-8"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src", "alt"]

import {
		useBrand
	} from "@/utilities/brand"

	
	const __default__ = { name: 'BrandCardLayout' } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// brand
	const brand = useBrand()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: _normalizeClass(_unref(brand).logos.loginCard.class),
            src: _unref(brand).logos.loginCard.src,
            alt: _unref(brand).logos.loginCard.alt
          }, null, 10, _hoisted_5)
        ]),
        _renderSlot(_ctx.$slots, "default"),
        (_unref(brand).logos.loginFooter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("a", {
                href: _unref(brand).siteUrl,
                target: "_blank",
                class: "w-1/2"
              }, [
                _createElementVNode("img", {
                  src: _unref(brand).logos.loginFooter.src,
                  alt: _unref(brand).logos.loginFooter.alt
                }, null, 8, _hoisted_8)
              ], 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})